module.exports = __webpack_public_path__ + "static/img/logo.1676a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/logo.png
// module id = QB7A
// module chunks = 1